import { Star, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { ServiceListItem } from 'shared'
import { Card, CardContent } from './card'
import { categoryLabel } from 'shared'

type ServiceCardProps = {
  service: ServiceListItem
}

const ServiceCard = ({ service }: ServiceCardProps) => {
  return (
    <Link to={'/services/' + service.id} className="block">
      <Card className="transition-shadow hover:ring-foreground/20 hover:shadow-md">
        {service.imageUrl ? (
          <img src={service.imageUrl} alt={service.title} className="h-40 w-full object-cover" />
        ) : (
          <div className="h-40 bg-gradient-to-br from-primary/10 to-accent/10 rounded-t-xl" />
        )}
        <CardContent>
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-semibold truncate">{service.title}</h3>
            <div className="flex items-center gap-1 text-amber-500">
              <Star className="size-4 fill-current" />
              <span className="text-sm text-foreground">{service.rating.toFixed(1)}</span>
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-3">{categoryLabel(service.category)}</p>
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <MapPin className="size-4 text-muted-foreground" />
              <span>{service.city ?? 'Nearby'}</span>
            </div>
            <span>From ${service.priceFrom}</span>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}

export default ServiceCard
